import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';

export const generateConsolidateExcel = async (data, workingSensors, allFoods, locationInfo) => {
  if (!data || data.length === 0) {
    console.error('No hay datos para exportar');
    return;
  }

  const dates = data.map(row => new Date(row.date));
  const startDate = format(new Date(Math.min(...dates)), 'dd/MM/yyyy');
  const endDate = format(new Date(Math.max(...dates)), 'dd/MM/yyyy');
  
  const fileName = `Consumo Consolidado - ${locationInfo.farmName} - ${locationInfo.barnName} - Lote ${locationInfo.batchName} - ${startDate} - ${endDate}.xlsx`;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Consumo Consolidado');

  const foodNamesMap = allFoods.reduce((map, food) => {
    map[food.pk] = food.name;
    return map;
  }, {});

  const columns = [
    { key: 'date', width: 15 },
    { key: 'consume', width: 20 },
    { key: 'food_name', width: 40 }
  ];

  worksheet.columns = columns;

  const titleCell = worksheet.getCell('B1');
  titleCell.value = 'Consumo Consolidado';
  titleCell.font = { bold: true, size: 14 };
  titleCell.alignment = { horizontal: 'center' };

  const locationCell = worksheet.getCell('B2');
  locationCell.value = `${locationInfo.farmName} - ${locationInfo.barnName} - Lote ${locationInfo.batchName}`;
  locationCell.font = { bold: true };
  locationCell.alignment = { horizontal: 'center' };

  const dateRangeCell = worksheet.getCell('B3');
  dateRangeCell.value = `${startDate} - ${endDate}`;
  dateRangeCell.font = { italic: true };
  dateRangeCell.alignment = { horizontal: 'center' };

  worksheet.getColumn('B').width = 40;

  const headerRow = worksheet.getRow(5);
  headerRow.values = ['Data', 'Consumo Total (kg)', 'Ração'];
  headerRow.font = { bold: true };
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFEEEEEE' }
  };

  data.forEach((row, index) => {
    const rowData = {
      date: format(new Date(row.date), 'dd/MM/yyyy'),
      consume: Number(row.consume.toFixed(2)),
      food_name: foodNamesMap[row.food_id] || `Ração ${row.food_id}`,
    };

    const currentRow = worksheet.getRow(6 + index);
    currentRow.values = [rowData.date, rowData.consume, rowData.food_name];
  });

  worksheet.getColumn('date').alignment = { horizontal: 'center' };
  worksheet.getColumn('consume').alignment = { horizontal: 'center' };
  worksheet.getColumn('food_name').alignment = { horizontal: 'center' };
  
  worksheet.getColumn('food_name').width = Math.max(
    40,
    ...data.map(row => (foodNamesMap[row.food_id] || `Ração ${row.food_id}`).length + 2)
  );

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > 5) {
      const fill = rowNumber % 2 === 0 
        ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF8F9FA' } }
        : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
      row.eachCell(cell => {
        cell.fill = fill;
      });
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), fileName);
}; 